import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Libera a rota com token válido; caso contrário redireciona a /login. */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.isAutenticado() ? true : inject(Router).createUrlTree(['/login']);
};

/** Rota pública de login: se já autenticado, redireciona a /home. */
export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.isAutenticado() ? inject(Router).createUrlTree(['/home']) : true;
};
